(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["decentralizedRenderer"] = factory(require("react"));
	else
		root["decentralizedRenderer"] = factory(root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__3__) {
return 